/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    /* JS FOR PRODUCT IMAGE SLIDER */

document.addEventListener("DOMContentLoaded", function () {
  // Only run on mobile
  if (window.innerWidth > 768) return;

  const sliderWrapper = document.querySelector('product-images.product__images--mobile-slider');
  if (!sliderWrapper) return;

  const scrollContainer = sliderWrapper.querySelector('.product__slides');
  if (!scrollContainer) return;

  // Inject progress bar if it doesn't exist
  if (!sliderWrapper.nextElementSibling?.classList?.contains('mobile-slider-progress')) {
    const progressBarWrapper = document.createElement('div');
    progressBarWrapper.className = 'mobile-slider-progress';
    progressBarWrapper.innerHTML = '<div class="mobile-slider-progress__bar"></div>';
    sliderWrapper.insertAdjacentElement('afterend', progressBarWrapper);
  }

  const progressBar = document.querySelector('.mobile-slider-progress__bar');

  function updateProgressBar() {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const percent = (scrollLeft / maxScroll) * 100;
    progressBar.style.width = `${percent}%`;
  }

  scrollContainer.addEventListener('scroll', updateProgressBar, { passive: true });
  updateProgressBar();
});

document.addEventListener('DOMContentLoaded', function() {
  function updateClocks() {
    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

    const nyElement = document.getElementById('time-ny');
    const lonElement = document.getElementById('time-lon');
    const sydElement = document.getElementById('time-syd');

    if (nyElement) {
      nyElement.textContent = new Date().toLocaleTimeString('en-US', { ...options, timeZone: 'America/New_York' });
    }
    if (lonElement) {
      lonElement.textContent = new Date().toLocaleTimeString('en-GB', { ...options, timeZone: 'Europe/London' });
    }
    if (sydElement) {
      sydElement.textContent = new Date().toLocaleTimeString('en-AU', { ...options, timeZone: 'Australia/Sydney' });
    }
  }

  setInterval(updateClocks, 1000);
  updateClocks();
});


// BOF HIDING AND SELECTING OPTIONS ON PRODUCT PAGE //

function autoSelectOnlyOption2(scope = document) {
  scope.querySelectorAll('.product__selectors').forEach((selectors) => {
    const option2Inputs = selectors.querySelectorAll(
      '.selector-wrapper[data-option-position="2"] input[data-index="option2"]'
    );

    if (!option2Inputs.length) return;

    const validOption2 = Array.from(option2Inputs).filter((input) => {
      return !input.classList.contains('unavailable');
    });

    if (validOption2.length === 1) {
      const onlyOption = validOption2[0];

      if (!onlyOption.checked) {
        onlyOption.checked = true;
        onlyOption.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

function updateOption1StrikeState(scope = document) {
  scope.querySelectorAll('.product__selectors').forEach((selectors) => {
    const option2Inputs = selectors.querySelectorAll(
      '.selector-wrapper[data-option-position="2"] input[data-index="option2"]'
    );

    if (!option2Inputs.length) {
      selectors.classList.remove('option2-all-blocked');
      return;
    }

    const allBlocked = Array.from(option2Inputs).every((input) =>
      input.classList.contains('unavailable') ||
      input.classList.contains('sold-out')
    );

    selectors.classList.toggle('option2-all-blocked', allBlocked);
  });
}

function runVariantUIUpdates(scope = document) {
  requestAnimationFrame(() => {
    autoSelectOnlyOption2(scope);
    updateOption1StrikeState(scope);

    setTimeout(() => {
      autoSelectOnlyOption2(scope);
      updateOption1StrikeState(scope);
    }, 80);

    setTimeout(() => {
      autoSelectOnlyOption2(scope);
      updateOption1StrikeState(scope);
    }, 180);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__selectors').forEach((selectors) => {
    selectors.classList.remove('variant-interacted');
  });

  runVariantUIUpdates();
});

document.addEventListener('change', (event) => {
  if (
    event.target.matches('.product__selectors input[data-index="option1"]') ||
    event.target.matches('.product__selectors input[data-index="option2"]')
  ) {
    const selectors = event.target.closest('.product__selectors');
    if (!selectors) return;

    const hasOption2 = selectors.querySelector('.selector-wrapper[data-option-position="2"]');
    if (hasOption2) {
      selectors.classList.add('variant-interacted');
    }

    runVariantUIUpdates();
  }
});





// EOF HIDING AND SELECTING OPTIONS ON PRODUCT PAGE //


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// BOF QUICK FILTERS (metafield type links + IN STOCK toggle switch) //
// Shows the values of one product metafield (built from whatever values exist
// in the collection) plus an IN STOCK / ALL STOCK switch, next to FILTERS.
// Config per template: a "Quick filter config" Custom code section containing
//   <div data-dd-quick-filter="primary_type" hidden></div>
// (primary_type | secondary_type | tertiary_type).
// IN STOCK switch defaults to OFF (all stock); on = filter.v.availability=1.
// Needs the metafields + Availability switched on in Search & Discovery > Filters.
// Reads the checkboxes already in the theme's filter drawer, so no extra requests.
(function () {
  const marker = document.querySelector('[data-dd-quick-filter]');
  if (!marker) return;
  const typeParam = 'filter.p.m.custom.' + (marker.dataset.ddQuickFilter || '').trim();
  const AVAIL = 'filter.v.availability';
  const section = document.querySelector('[data-section-type="collection"]');
  const nav = section && section.querySelector('[data-collection-nav]');
  const sidebar = section && section.querySelector('[data-collection-sidebar]');
  if (!nav || !sidebar) return;

  const bar = document.createElement('div');
  bar.className = 'dd-qf';
  const types = document.createElement('div');
  types.className = 'dd-qf__types';
  types.id = 'dd-qf-types';
  // Phone + portrait tablet: the type links sit in a dropdown (CATEGORY ▾). Label is
  // configurable per template with data-dd-quick-label="Material" on the marker div.
  const ddBtn = document.createElement('button');
  ddBtn.type = 'button';
  ddBtn.className = 'dd-qf__dd';
  ddBtn.setAttribute('aria-expanded', 'false');
  ddBtn.setAttribute('aria-controls', 'dd-qf-types');
  ddBtn.innerHTML =
    '<span class="dd-qf__dd-label"></span><span class="dd-qf__dd-count"></span>' +
    '<svg class="dd-qf__dd-chev" viewBox="0 0 10 6" width="10" height="6" aria-hidden="true" focusable="false">' +
    '<path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>';
  ddBtn.querySelector('.dd-qf__dd-label').textContent = (marker.dataset.ddQuickLabel || 'Category').trim();
  const ddCount = ddBtn.querySelector('.dd-qf__dd-count');
  const avail = document.createElement('div');
  avail.className = 'dd-qf__avail';
  // IN STOCK + toggle switch. On (default) = in stock only; off = all stock.
  avail.innerHTML =
    '<button type="button" class="dd-qf__stock" role="switch" aria-label="In stock only">' +
    '<span class="dd-qf__stock-label">In stock</span>' +
    '<span class="dd-qf__switch" aria-hidden="true"></span>' +
    '</button>';
  const stockBtn = avail.firstChild;
  bar.append(ddBtn, types, avail);
  const setOpen = (open) => {
    bar.classList.toggle('is-open', open);
    ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  ddBtn.addEventListener('click', () => setOpen(!bar.classList.contains('is-open')));
  document.addEventListener('click', (e) => { if (!bar.contains(e.target)) setOpen(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  const group = nav.querySelector('.popout--group');
  group ? group.after(bar) : nav.prepend(bar);
  nav.classList.add('dd-qf-nav'); // lets CSS move the bar to its own row on mobile/tablet

  const inputs = (name) => [...sidebar.querySelectorAll(`input[type="checkbox"][name="${name}"]`)];
  const inStockInput = () => inputs(AVAIL).find((i) => i.value === '1');
  const submit = (fallbackInput) => {
    // Broadcast's own AJAX filtering (instant); fall back to its debounced input listener.
    const form = sidebar.querySelector('collection-filters-form');
    if (form && typeof form.submitForm === 'function') form.submitForm();
    else fallbackInput.dispatchEvent(new Event('input', { bubbles: true }));
  };

  function makeBtn(input) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'dd-qf__btn';
    b.textContent = input.value;
    b.dataset.value = input.value;
    b.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
    b.disabled = input.disabled;
    return b;
  }

  function render() {
    // Tag the primary/secondary/tertiary groups in the drawer so CSS can hide them
    // on tablet/desktop (where the quick links show). They must stay in the drawer
    // (just hidden) because the quick links work by ticking these checkboxes.
    sidebar.querySelectorAll('input[name^="filter.p.m.custom."][name$="_type"]').forEach((i) => {
      if (/\.(primary|secondary|tertiary)_type$/.test(i.name)) {
        const g = i.closest('.filter-group');
        if (g) g.classList.add('dd-qf-group');
      }
    });
    types.replaceChildren(...inputs(typeParam).map(makeBtn));
    types.hidden = !types.children.length;
    ddBtn.hidden = types.hidden;
    const activeCount = inputs(typeParam).filter((i) => i.checked).length;
    ddCount.textContent = activeCount ? ` (${activeCount})` : '';
    const a = inStockInput();
    avail.hidden = !a;
    if (a) {
      stockBtn.setAttribute('aria-checked', a.checked ? 'true' : 'false');
      stockBtn.title = a.checked ? 'Showing in stock only. Click to show all stock' : 'Showing all stock. Click to show in stock only';
      stockBtn.disabled = a.disabled && !a.checked;
    }
    bar.hidden = types.hidden && avail.hidden;
  }

  types.addEventListener('click', (e) => {
    const b = e.target.closest('.dd-qf__btn');
    if (!b || b.disabled) return;
    const input = inputs(typeParam).find((i) => i.value === b.dataset.value);
    if (!input) return;
    input.checked = !input.checked;
    b.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
    setOpen(false);
    submit(input);
  });

  stockBtn.addEventListener('click', () => {
    const a = inStockInput();
    if (!a || stockBtn.disabled) return;
    a.checked = !a.checked;
    stockBtn.setAttribute('aria-checked', a.checked ? 'true' : 'false');
    submit(a);
  });

  render();
  // Broadcast swaps the drawer HTML after each filter change; re-sync the links.
  new MutationObserver(render).observe(sidebar, { childList: true });
})();
// EOF QUICK FILTERS //
